import { Div } from '../../../base/components/native/div'
import { Input } from '../../../base/components/native/input'
import { EASE, X } from '../../../base/helpers/style'
import { GenerateButton } from './generate-button'

export const MainInput = () => {

    const base = Div()
    const placeholder = Div('E.g. bear in a dark forest')
    const input = Input()
    const generate = GenerateButton()
    base.append(input, placeholder, generate)

    input.on('input', () => {
        if (input.getValue().length > 0) {
            placeholder.style({ opacity: '0', ...X(30) })
        } else {
            placeholder.style({ opacity: '1', ...X(0) })
        }
    })
    generate.el.onclick =  () => {
        if (input.getValue().length === 0) return
        base.emit('submit', input.getValue())
    }
    input.el.addEventListener('keydown', (e: KeyboardEvent) => {
        if (input.getValue().length === 0) return
        
        if (e.key === 'Enter') {
        console.log(e.key);

            base.emit('submit', input.getValue())
        }
    })

    input.cssClass({
        position: 'absolute',
        left: '18px',
        top: '0',
        width: 'calc(100% - 236px)',
        height: '60px',
        border: 'none',
        outline: 'none',
        fontFamily: 'Roboto',
        fontWeight: '400',
        fontSize: '20px',
        lineHeight: '22px',
        color: '#000',
        '@media (max-width: 520px)': {
            width: 'calc(100% - 40px)',
        }
    })
    placeholder.cssClass({
        ...EASE(.16),
        pointerEvents: 'none',
        position: 'absolute',
        top: '20px',
        left: '20px',
        fontFamily: 'Roboto',
        fontWeight: '400',
        fontSize: '20px',
        lineHeight: '22px',
        color: '#777777',
    })
    base.cssClass({
        position: 'sticky',
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
        zIndex: '99',
        top: '10px',
        height: '60px',
        width: 'calc(100% - 20px)',
        maxWidth: '979px',
        borderRadius: '10px',
        backgroundColor: '#fff',
        margin: '0 auto 60px' ,
        '@media (max-width: 520px)': {
            height: '120px',
        }
    })

    return base
}